module.exports = __webpack_public_path__ + "img/IMG_1024_L_Foamcore.dc165d74.jpg";